module.exports = __webpack_public_path__ + "img/combo-offer-animate.60f802bb.svg";